module.exports = __webpack_public_path__ + "img/6_43.41406935.png";